import styled from 'styled-components'

export const SubmitButton = styled.button`
  position: relative;
  background: transparent;
  text-decoration: none;
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 20px;
  text-transform: uppercase;
  width: 100%;
  text-align: center;
  height: 52px;
  margin-top: 32px;
  color: #fff;
  background: linear-gradient(180deg, #6be89c 0%, #4bd882 100%);
  box-shadow: 0px 8px 12px rgba(192, 242, 212, 0.8);
  border-radius: 10px;
  border: none;
  :hover {
    cursor: pointer;
  }
  svg {
    position: absolute;
    right: 19px;
    top: 19px;
  }
`
